import React, { memo } from 'react';
import { View, Text, Image } from '@tarojs/components';
import woodenSlot from '@/assets/sheep/wooden-slot.png';
import { Card } from '@/types/game';
import GameCard from '@/components/GameCard';
import styles from './index.module.scss';

export const SLOT_STEP = 85;
const CardSlot: React.FC<{ queue: Card[]; maxSlots?: number; eliminatingIds?: string[]; hiddenIds?: string[] }> =
  ({ queue, maxSlots = 7, eliminatingIds = [], hiddenIds = [] }) => (
    <View className={styles.slotContainer}>
      <Image className={styles.woodenSlot} src={woodenSlot} mode='scaleToFill' />
      <Text className={styles.count + (queue.length >= 6 ? ' ' + styles.warning : '')}>{queue.length}/{maxSlots}</Text>
      <View className={styles.slots} style={{ width: ((maxSlots - 1) * SLOT_STEP + 84) + 'rpx' }}>
        {Array.from({ length: maxSlots }, (_, index) => (
          <View id={'slot-target-' + index} key={index} className={styles.emptySlot} style={{ left: (index * SLOT_STEP) + 'rpx' }} />
        ))}
        {queue.map((card, index) => (
          <View key={card.id} data-slot-card={card.id} data-slot-hidden={hiddenIds.includes(card.id) ? 'true' : 'false'} className={styles.tile}
            style={{ transform: 'translate3d(' + (index * SLOT_STEP) + 'rpx,0,0)', opacity: hiddenIds.includes(card.id) ? 0 : 1 }}
          >
            <View className={eliminatingIds.includes(card.id) ? styles.eliminating : ''}>
              <GameCard card={{ ...card, isCover: false }} small />
            </View>
          </View>
        ))}
      </View>
    </View>
  );
export default memo(CardSlot);
